import Link from 'next/link';
import styled, { css } from 'styled-components';

export const Tabs = styled.nav`
  display: flex;
  gap: 25px;
  height: 45px;
  padding: 11px 0 15px;
`;

export const Tab = styled(Link)<{ $isActive: boolean }>`
  position: relative;
  color: ${({ theme }) => theme.palette.secondary.labels};
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${({ theme }) => theme.palette.primary.labels};

      &::after {
        position: absolute;
        right: 0;
        bottom: -15px;
        left: 0;
        height: 2px;
        background-color: ${({ theme }) => theme.palette.primary.labels};
        content: '';
      }
    `}
`;
